import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getUser } from '../store/slices/authSlice';
import { clearPaymentsError, fetchPlans, fetchProducts, getPaymentsState } from '../store/slices/paymentsSlice';

const usePayments = () => {
    const dispatch = useDispatch();
    const { plansList, productsList } = useSelector(getPaymentsState);
    const user = useSelector(getUser);

    useEffect(() => {
        return () => {
            dispatch(clearPaymentsError());
        };
    }, [dispatch]);

    useEffect(() => {
        if (user.id && (!plansList.length || !productsList.length)) {
            dispatch(fetchPlans());
            dispatch(fetchProducts());
        }
    }, [dispatch, user.id]);
};
export default usePayments;
